import React, { useState } from "react";
import Header from "../include/Header";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import CustomBreadcrumb from "../include/Breadcrumb";
import axios from "axios";
import { API_URL } from "../config/api";

function Addproduct() {

  // ===========================
  // 🧠 FORM STATE (PRODUCT DATA)
  // ===========================
  const [formData, setFormData] = useState({
    name: "",        // product name
    description: "", // product description
    price: "",       // product price
    image: null,     // product image file
  });

  // ===========================
  // ✍️ INPUT CHANGE HANDLER
  // ===========================
  const handleChange = (e) => {

    // agar image select ho
    if (e.target.name === "image") {

      setFormData({
        ...formData,
        image: e.target.files[0], // file store
      });

    } else {

      // normal input (name, price, description)
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
    }
  };

  // ===========================
  // 🚀 ADD PRODUCT API CALL
  // ===========================
  const handleSubmit = async (e) => {

    e.preventDefault(); // page reload stop

    const data = new FormData();

    // form values add to FormData
    data.append("name", formData.name);
    data.append("description", formData.description);
    data.append("price", formData.price);
    data.append("image", formData.image);

    try {

      const res = await axios.post(
        `${API_URL}/add-product`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      alert(res.data.message);

      // ===========================
      // 🧹 FORM RESET AFTER SUCCESS
      // ===========================
      setFormData({
        name: "",
        description: "",
        price: "",
        image: null,
      });

      // file input manually reset
      document.getElementById("image").value = "";

    } catch (error) {
  console.log("Status:", error.response?.status);
  console.log("Data:", error.response?.data);
  console.log("Error:", error);

  alert(JSON.stringify(error.response?.data));
}
  };

  // ===========================
  // 🖥️ UI START
  // ===========================
  return (
    <>
      <Header />

      <div className="ved">

        <Container className="my-5">

          <CustomBreadcrumb title="Add Product" />

          <Row className="align-items-center shadow p-4 rounded bg-white">

            {/* ===========================
                🖼️ LEFT IMAGE SECTION
            =========================== */}
            <Col md={6}>

              <img
                src="https://picsum.photos/600/500"
                alt="Product"
                className="img-fluid rounded"
              />

            </Col>

            {/* ===========================
                🧾 RIGHT FORM SECTION
            =========================== */}
            <Col md={6}>

              <div className="text-start">

                <h2 className="mb-4">
                  Add Product
                </h2>

                <Form onSubmit={handleSubmit}>

                  {/* PRODUCT NAME */}
                  <Form.Group className="mb-3">

                    <Form.Label>Product Name</Form.Label>

                    <Form.Control
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter product name"
                      required
                    />

                  </Form.Group>

                  {/* DESCRIPTION */}
                  <Form.Group className="mb-3">

                    <Form.Label>Description</Form.Label>

                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="description"
                      value={formData.description}
                      onChange={handleChange}
                      placeholder="Enter product description"
                      required
                    />

                  </Form.Group>

                  {/* PRICE */}
                  <Form.Group className="mb-3">

                    <Form.Label>Price</Form.Label>

                    <Form.Control
                      type="number"
                      name="price"
                      value={formData.price}
                      onChange={handleChange}
                      placeholder="Enter product price"
                      required
                    />

                  </Form.Group>

                  {/* IMAGE */}
                  <Form.Group className="mb-3">

                    <Form.Label>Product Image</Form.Label>

                    <Form.Control
                      id="image"
                      type="file"
                      name="image"
                      accept="image/*"
                      onChange={handleChange}
                      required
                    />

                  </Form.Group>

                  {/* SUBMIT BUTTON */}
                  <Button
                    variant="success"
                    type="submit"
                    className="w-100"
                  >
                    Add Product
                  </Button>

                </Form>

              </div>

            </Col>

          </Row>

        </Container>

      </div>

    </>
  );
}

export default Addproduct;